module.exports = __webpack_public_path__ + "static/media/pic-5.1e9b789f.jpg";